/* ZilZal — rarity filter, Bloxcart-style list, built from the collection itself.

   sections/collection-shelves.liquid hardcodes one list for every page:
     'Common,Uncommon,Rare,Epic,Legendary,Mythic,Limited'
   MM2 uses Godly / Ancient / Unique / Vintage, Blox Fruits uses another set
   again, so most collections showed seven rows that matched nothing.

   This discards those buttons and rebuilds the list from the rarities actually
   present on the cards (.bxc-card[data-rarity]), so each collection shows only
   its own. The rebuilt buttons keep the .bxc-rar class and the data-bxc-rar
   attribute, so the section's existing click handler and filtering still work
   with no change to that 62KB file.

   It also paints each card's top rarity strip. bxc-global.css only declares
   --rar-c for the same seven names, so any other rarity would render a
   colourless strip; setting the variable here keeps one palette for both the
   filter and the cards.

   Counts are measured ONCE, before any filtering. Selecting a category empties
   #product-grid-container and re-appends only matching cards, so a later count
   would report what is on screen rather than what the collection holds. */
(function () {
  var ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M12 1.8 21 7v10l-9 5.2L3 17V7Zm-2.5 7.7v5h5v-5Z"/></svg>';

  /* Known rarity colours, keys lowercased. Anything unlisted still renders — it
     falls back to the neutral tone rather than being dropped, so a rarity added
     in the admin never disappears just because this map has not caught up. */
  var COLORS = {
    common: '#9aa4b2',
    uncommon: '#41d07a',
    rare: '#3b82f6',
    epic: '#a855f7',
    legendary: '#f59e0b',
    mythic: '#ef4444',
    mythical: '#ef4444',
    limited: '#22d3ee',
    godly: '#f97316',
    ancient: '#8b5cf6',
    unique: '#ef4444',
    vintage: '#ec4899',
    divine: '#eab308',
    celestial: '#38bdf8',
    exotic: '#f472b6',
    chroma: '#22d3ee',
    secret: '#64748b',
    exclusive: '#c9a646',
    event: '#34d399',
    prismatic: '#e879f9',
    super: '#14b8a6'
  };
  var FALLBACK = '#94a3b8';

  /* Preferred order, weakest first. Unknown values sort after these,
     alphabetically, so the list is stable between loads rather than following
     whatever order the products happen to be in. */
  var ORDER = [
    'common', 'uncommon', 'rare', 'epic', 'legendary', 'mythic', 'mythical',
    'super', 'vintage', 'unique', 'ancient', 'godly', 'divine', 'prismatic', 'celestial', 'exotic',
    'chroma', 'event', 'exclusive', 'limited', 'secret'
  ];

  function colorFor(name) {
    return COLORS[String(name).toLowerCase()] || FALLBACK;
  }

  var measured = null;

  function measure() {
    var map = {};
    var cards = document.querySelectorAll('#product-grid-container .bxc-card[data-rarity]');
    Array.prototype.forEach.call(cards, function (c) {
      var r = (c.getAttribute('data-rarity') || '').trim();
      if (!r) return;
      map[r] = (map[r] || 0) + 1;
      c.style.setProperty('--rar-c', colorFor(r));
    });
    return map;
  }

  function sortNames(names) {
    return names.sort(function (a, b) {
      var ia = ORDER.indexOf(a.toLowerCase());
      var ib = ORDER.indexOf(b.toLowerCase());
      if (ia === -1 && ib === -1) return a.localeCompare(b);
      if (ia === -1) return 1;
      if (ib === -1) return -1;
      return ia - ib;
    });
  }

  function slug(name) {
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function build() {
    var wrap = document.querySelector('[data-bxc-rarities]');
    if (!wrap) return;

    if (!measured) measured = measure();
    /* Speed (Oct 2026): sections/collection-shelves.liquid now draws this list itself from the same data, in the
       same order and markup, so it is in the first paint (the rebuild here moved the whole rail on desktop).
       The cards' strip colours above are still painted here; the list is left alone. */
    if (wrap.hasAttribute('data-zz-server')) return;
    var names = sortNames(Object.keys(measured));

    /* No rarity data anywhere in this collection: hide the group rather than
       leave a heading above blank space. */
    var group = wrap.closest('.bxc-fgroup');
    if (!names.length) {
      if (group) group.style.display = 'none';
      return;
    }
    if (group) group.style.display = '';

    /* Keep whatever was already ticked, so a re-render in the theme editor does
       not silently clear the selection. */
    var on = {};
    Array.prototype.forEach.call(wrap.querySelectorAll('.bxc-rar.is-on'), function (b) {
      on[b.getAttribute('data-bxc-rar')] = true;
    });

    var html = '';
    names.forEach(function (name) {
      var n = measured[name] || 0;
      html +=
        '<button type="button" class="bxc-rar bxc-rar--' + slug(name) + (on[name] ? ' is-on' : '') +
        '" data-bxc-rar="' + esc(name) + '" data-zz-built="1">' +
        '<span class="zzr-ic">' + ICON + '</span>' +
        '<span class="zzr-lbl">' + esc(name) + '</span>' +
        '<span class="zzr-n">(' + n + ')</span>' +
        '<span class="zzr-box" aria-hidden="true"></span>' +
        '</button>';
    });
    wrap.innerHTML = html;

    /* Colour is set inline with !important on purpose. The section stylesheet
       carries `.bxc-rar.is-on { color:#fff !important }`, and a stylesheet
       !important beats a plain inline style — only an inline !important wins,
       which is what keeps the mark and checkbox on their rarity colour once a
       row is ticked. */
    Array.prototype.forEach.call(wrap.querySelectorAll('.bxc-rar'), function (btn) {
      btn.style.setProperty('color', colorFor(btn.getAttribute('data-bxc-rar')), 'important');
    });
  }

  function init() { build(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { measured = null; init(); });
})();
